/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import * as React from "react"
import classnames from "classnames"
import { Link } from "react-router-dom"
import { Container, Col, Row } from "reactstrap"
import { withRouter, RouteComponentProps, NavLink } from "react-router-dom"

import { ReactComponent as SeeMore } from "media/svg/seeMore.svg"
import { ReactComponent as UserIcon } from "media/svg/userIcon.svg"

import { Paper } from "components"
import { useAuth } from "hooks"

import { products, logos } from "./data"
import "./MegaMenu.scss"

interface MegaMenu extends RouteComponentProps {
	foo?: string
}

interface List {
	items: { title: string; products: { text: string; to: string }[] }
}

const List: React.FC<List> = ({ items }) => {
	return (
		<>
			<span>{items.title}</span>
			<ul>
				{items.products.map((item) => (
					<li key={item.to}>
						<Link to={item.to}>{item.text}</Link>
					</li>
				))}
			</ul>
		</>
	)
}

const ShopSubmenu: React.FC<{ open: boolean }> = ({ open }) => {
	return (
		<Paper
			className={classnames("mega-menu__dropdown__container", {
				"mega-menu__dropdown__container--open": open,
			})}
		>
			<Row>
				{products.map((product) => (
					<Col
						key={product.title}
						lg={2}
						className="mega-menu__dropdown"
					>
						<List items={product} />
					</Col>
				))}
				<Col>
					<Row>
						{logos.map((logo, index) => (
							<Col
								key={`${logo.name}-${logo.to}`}
								className={classnames({ "mt-3": index >= 3 })}
								lg={4}
							>
								<Link to={logo.to}>
									<img
										width="240"
										height="110"
										className="img-fluid"
										src={open ? logo.image : ""}
										alt={logo.name}
									/>
								</Link>
							</Col>
						))}
					</Row>
				</Col>
			</Row>
		</Paper>
	)
}

const endpoints = [
	{ text: "صفحه نخست", to: "/" },
	{
		text: "فروشگاه",
		to: "/shop",
		submenu: <ShopSubmenu open={false} />,
	},
	{ text: "مرکز دانلود", to: "/download-center" },
	{ text: "مقالات", to: "/blog" },
	{ text: "درباره ما", to: "/about-us" },
]

const MegaMenu: React.FC<MegaMenu> = ({ location }) => {
	const [width, setWidth] = React.useState(0)
	const [right, setRight] = React.useState(0)
	const loggedIn = useAuth()
	const [showMegaMenu, setShowMegaMenu] = React.useState(false)

	function onClick(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
		const width = event.currentTarget.offsetWidth
		const left = event.currentTarget.offsetLeft
		const parentWidth = event.currentTarget.parentElement!.parentElement!
			.offsetWidth

		setWidth(width)
		setRight(parentWidth - (left + width))
	}

	React.useEffect(() => {
		if (
			!endpoints.some((endpoint) =>
				endpoint.to === "/"
					? location.pathname === endpoint.to
					: location.pathname.startsWith(endpoint.to)
			)
		) {
			setRight(0)
			setWidth(0)
		}
	}, [location.pathname, setRight, setWidth])

	return (
		<>
			<Paper className="mega-menu">
				<Container>
					<nav>
						<div
							className="mega-menu__active"
							style={{
								width: `${width}px`,
								transform: `translateX(-${right}px)`,
							}}
						/>
						<ul className="mega-menu__list">
							{endpoints.map(({ submenu, text, to }) => (
								<li
									className="mega-menu__listitem"
									onMouseEnter={() =>
										submenu && setShowMegaMenu(true)
									}
									onMouseLeave={() =>
										submenu && setShowMegaMenu(false)
									}
									onClick={() =>
										submenu && setShowMegaMenu(false)
									}
									key={to}
								>
									<NavLink
										exact
										to={to}
										onClick={onClick}
										activeClassName="mega-menu__listitem--active"
									>
										{text}
										{submenu && (
											<SeeMore
												height="10px"
												width="10px"
												className="mr-1 d-none d-lg-inline"
											/>
										)}
									</NavLink>
									{submenu &&
										React.cloneElement(submenu, {
											open: showMegaMenu,
										})}
								</li>
							))}
						</ul>
						<div className="mega-menu__left d-none d-md-inline">
							{loggedIn ? (
								<Link to="/dashboard">
									<UserIcon className="ml-1" />
									خوش آمدید
								</Link>
							) : (
								<Link to="/login">
									<UserIcon className="ml-1" />
									ورود یا ثبت نام
								</Link>
							)}
						</div>
					</nav>
				</Container>
			</Paper>
		</>
	)
}

export default withRouter(MegaMenu)
